import { render, staticRenderFns } from "./QrCodeListSettings.vue?vue&type=template&id=35421f17&scoped=true"
import script from "./QrCodeListSettings.vue?vue&type=script&lang=ts"
export * from "./QrCodeListSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35421f17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35421f17')) {
      api.createRecord('35421f17', component.options)
    } else {
      api.reload('35421f17', component.options)
    }
    module.hot.accept("./QrCodeListSettings.vue?vue&type=template&id=35421f17&scoped=true", function () {
      api.rerender('35421f17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/QrCodeListSettings.vue"
export default component.exports